import { format, parseISO, isValid } from 'date-fns';
import {
  DATE_TIME_FORMAT_FOR_DATE_PICKER,
  APP_DEFAULT_TIME_ZONE,
  DATA_TABLE_DATE_FORMAT,
  DATE_ISO_FORMAT,
  DATE_FORMAT_FOR_EXPORT,
} from './constants';
import moment from 'moment';
import { ValueGetterParams } from 'ag-grid-community';

export const getDisplayDateByTimeZone = (
  dateString: string,
  format?: string,
) => {
  if (isFormattedDate(dateString)) {
    return dateString;
  }

  if (!isValid(parseISO(dateString))) {
    return '-';
  }

  return moment
    .utc(dateString)
    .tz(APP_DEFAULT_TIME_ZONE)
    .format(format ? format : DATA_TABLE_DATE_FORMAT);
};

export const getMomentDateByAppTimeZone = (
  dateString: string,
) => {
  
  var date = moment
    .utc(dateString)
    .tz(APP_DEFAULT_TIME_ZONE);

  return date;
};

export const getDateByFormat = (dateString: Date, dateFormat: string) => {
  return moment(dateString).format(dateFormat);
};

export const formatDateToISOString = (dateString: string) => {
  if (!isValid(parseISO(dateString))) {
    return '-';
  }
  //return parseISO(dateString).toISOString().replace('T', ' ').replace('Z', '');
  return moment.utc(dateString).tz(APP_DEFAULT_TIME_ZONE).format(DATE_FORMAT_FOR_EXPORT)
};

export const formatDateToISOStringForDataView = (dateString: string) => {
  if (!isValid(parseISO(dateString))) {
    return '-';
  }
  return moment.utc(dateString).format(DATE_FORMAT_FOR_EXPORT)
};

export const getFormattedDateToString = (dateString: string) => {
  if (!isValid(parseISO(dateString))) {
    return '-';
  }
  return moment(dateString).tz(APP_DEFAULT_TIME_ZONE).format(DATE_FORMAT_FOR_EXPORT)
};

export const getTimezoneOffset = () => {
  return getNewDateByTimeZone().getTimezoneOffset();
};

export const convertToAppTimeZone = (dateString: string) => {
  if (!isValid(parseISO(dateString))) {
    return '-';
  }
  return new Date(dateString).toLocaleString('en-US', {
    timeZone: APP_DEFAULT_TIME_ZONE,
  });
};

export interface ESTDateProps {
  dateTimeFormat?: string;
  isStartOf?: boolean;
  isEndOf?: boolean;
}

export const getNewDateByTimeZone = (estDateProps?: ESTDateProps) => {
  var dateFormat = estDateProps?.dateTimeFormat
    ? estDateProps.dateTimeFormat
    : DATE_TIME_FORMAT_FOR_DATE_PICKER;
  var dateWithTimeZone = moment.tz(APP_DEFAULT_TIME_ZONE);

  if (estDateProps?.isStartOf) {
    dateWithTimeZone.startOf('day');
  } else if (estDateProps?.isEndOf) {
    dateWithTimeZone.endOf('day');
  }

  return new Date(dateWithTimeZone.format(dateFormat));
};

export const getCurrentUTCTime = (dateFormat?: string) => {
  const utcDate = moment.utc();
  const format = dateFormat ? dateFormat : DATE_ISO_FORMAT;
  return utcDate.format(format);
};

const isFormattedDate = (date: string) => {
  return date?.includes('AM') || date?.includes('PM');
};

export const getDateForGridTable = (params: ValueGetterParams) => {
  let field = params?.colDef?.field ? params.colDef.field : '';
  return params.data[field] ? getDisplayDateByTimeZone(params.data[field]) : '';
};

export const getCurrentUTCDate = () => {
  return moment.utc();
}

export const utcToEtDateFormatter = (utcDateTime:any,dateFormat:string) => {
  const dateTime = utcDateTime
  ?.trim()
  .replaceAll('"', '');
  const dateTimeET =  getDisplayDateByTimeZone(dateTime, dateFormat).replace('T', ' ');
  return dateTimeET
}

export const getStatusFromStartAndEndDate = (startDateTime:any,endDateTime:any) =>{
  const currentDateTime = new Date()
  return (
        moment(startDateTime).isSameOrBefore(
        moment(currentDateTime),
      ) &&
        moment(endDateTime).isSameOrAfter(
        moment(currentDateTime),
      )
      ? 'Active'
      : moment(endDateTime).isSameOrBefore(
        moment(currentDateTime),
      )
      ? 'Expired'
      :  moment(startDateTime).isAfter(moment(currentDateTime))
      ? 'Future'
      : ''
  );
}

export const getMomentMinDateTimeByAppTimeZone = (start_date_time: any) => {
  let currentDateTime = getMomentDateByAppTimeZone(String(getCurrentUTCTime()));
  let startDateTime = getMomentDateByAppTimeZone(start_date_time);
  return startDateTime.isBefore(currentDateTime) ? currentDateTime : startDateTime;
}

export const addMinutes = (addMinutes: any, startDateTime: any) => {
  const minDate = moment(getMomentDateByAppTimeZone(startDateTime))
    .add(addMinutes, 'minutes')
    .toDate();
  return minDate;
};